export default __webpack_public_path__ + "static/media/01.69f3ee06.png";